<template>
  <div class="arrow-box flex flex-ali-center" :style="style">
    <div class="arrow-right" :style="arrowStyle"></div>
    <div class="center">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    width: {
      default: 200
    },
    height: {
      type: Number,
      default: 2
    },
    gap: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      
    };
  },
  computed:{
    style(){
      return {
        width: isNaN(this.width) ? this.width : `${this.width}px`,
        margin: `0 ${this.gap + 15}px 0 ${this.gap}px`
      }
    },
    arrowStyle(){
      return {
        height: `${this.height}px`
      }
    }
  },
  mounted(){
  },
  methods:{
    
  }
};
</script>
<style lang="less" scoped>
@arrow-height: 5px;
@arrow-width: 15px;
@arrow-color: #cfcfcf;
.arrow-box{
  position: relative;
  .arrow-right {
    width: 100%;
    background-color: @arrow-color;
    position: relative;
    &::after {
      content: '';
      position: absolute;
      right: -@arrow-width;
      top: 50%;
      transform: translateY(-50%);
      border-top: @arrow-height solid transparent;
      border-bottom: @arrow-height solid transparent;
      border-left: @arrow-width solid @arrow-color;
    }
  }
  .center{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
  }
}
</style>
